import { Col, FormInstance, Row } from 'antd';
import React, { FC, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { IntegrationField } from 'api/integrations';
import { ExternalResourceInputs } from 'api/tasks';
import { Form } from 'components/atoms/form';
import {
  defaultJiraFieldIds,
  fullWidthItems,
  generateFormFields,
} from 'components/molecules/integrations-commons';
import { setDirtyState } from 'data/templates';
import { useTranslation } from 'hooks/use-translation';

type JiraTemplatesForm = {
  form: FormInstance<ExternalResourceInputs>;
  onChange: () => void;
  fieldsList?: IntegrationField[];
  disabled?: boolean;
};

export const JiraTemplatesFieldsForm: FC<JiraTemplatesForm> = ({
  form,
  onChange,
  fieldsList,
  disabled,
}) => {
  const requiredMessage = useTranslation('input.required');
  const dispatch = useDispatch();

  useEffect(() => {
    queueMicrotask(() =>
      form.validateFields().catch(() => {
        dispatch(
          setDirtyState({
            id: 0,
            _state: false,
          }),
        );
      }),
    );
  }, [form, dispatch]);

  return (
    <Form
      layout="vertical"
      form={form}
      onValuesChange={onChange}
      scrollToFirstError
      preserve={false}
    >
      <Row gutter={[16, 16]}>
        {(fieldsList ?? [])
          .sort((a, b) => (a.required === b.required ? 0 : a.required ? -1 : 1))
          .map(
            (field) =>
              !defaultJiraFieldIds.includes(field.integrationFieldId) && (
                <Col
                  span={
                    fullWidthItems.includes(field.integrationFieldId) ? 24 : 12
                  }
                >
                  <Form.Item
                    label={
                      <FormattedMessage
                        id={`jira.fields.${field.fieldLabel?.toLowerCase()}`}
                        values={{ label: field.fieldLabel }}
                        defaultMessage={field.fieldLabel}
                      />
                    }
                    name={field.integrationFieldId}
                    rules={[
                      {
                        required: field.required,
                        message: requiredMessage,
                      },
                    ]}
                    getValueFromEvent={(data) => data.valueStr}
                    preserve={false}
                  >
                    {generateFormFields(
                      field,
                      field.metaData?.options ?? [],
                      disabled,
                    )}
                  </Form.Item>
                </Col>
              ),
          )}
      </Row>
    </Form>
  );
};
